import React, { ComponentProps } from 'react'

import { clsx } from 'clsx'

import { classNames } from '@/utils/helpers.ts'

interface ToggleProps extends ComponentProps<'input'> {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  checked: boolean
  disabled?: boolean
  uniqKey?: string
}

export const Toggle = ({ checked, disabled, name, ...props }: ToggleProps) => {
  return (
    <div
      className={classNames('flex cursor-pointer items-center', {
        'cursor-not-allowed opacity-50': disabled,
      })}
    >
      <input
        id={`toggle-${name}-${props.uniqKey}`}
        type="checkbox"
        className="hidden"
        checked={checked}
        disabled={disabled}
        {...props}
      />
      <label
        htmlFor={`toggle-${name}-${props.uniqKey}`}
        className={clsx(
          'relative flex h-[25px] w-[45px] items-center',
          'select-none',
        )}
      >
        <div
          className={clsx(
            'h-full w-full cursor-pointer rounded-[8.2px] shadow-inner',
            {
              'bg-primary-500': checked,
              'bg-secondary-100': !checked,
            },
          )}
        />
        <div
          className={clsx(
            'absolute inset-x-0 h-[18px] w-[20px] transform cursor-pointer rounded-[8.2px] bg-card transition-transform duration-300 dark:bg-white',
            {
              'translate-x-full': checked,
              'translate-x-[4.5px] dark:bg-card': !checked,
            },
          )}
        />
      </label>
    </div>
  )
}
